import { render, staticRenderFns } from "./team-settings.vue?vue&type=template&id=1a3c33e5&scoped=true"
import script from "./team-settings.vue?vue&type=script&lang=js"
export * from "./team-settings.vue?vue&type=script&lang=js"
import style0 from "./team-settings.vue?vue&type=style&index=0&id=1a3c33e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c33e5",
  null
  
)

export default component.exports